"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var icon_1 = __importDefault(require("../icon"));
var useConfig_1 = __importDefault(require("./../_util/useConfig"));
function Pagination(props) {
    var _a = props.pageIndex, pageIndex = _a === void 0 ? 1 : _a, _b = props.pageSize, pageSize = _b === void 0 ? 10 : _b, _c = props.total, total = _c === void 0 ? 0 : _c, onPagingChange = props.onPagingChange, style = props.style, className = props.className, disabled = props.disabled, _d = props.placeholder, placeholder = _d === void 0 ? '跳至' : _d, _e = props.pageText, pageText = _e === void 0 ? '页' : _e, _f = props.goText, goText = _f === void 0 ? 'Go' : _f;
    // eslint-disable-next-line no-console
    var pageSizeTransform = pageSize > 0 ? pageSize : 10;
    var totalPage = Math.ceil(total / pageSizeTransform);
    var pageIndexState = pageIndex < 1 ? 1 : pageIndex;
    if (pageIndexState > totalPage) {
        pageIndexState = totalPage;
    }
    var _g = react_1.default.useState(pageIndexState), currentPage = _g[0], setCurrentPage = _g[1];
    var _h = react_1.default.useState(7), range = _h[0], setRange = _h[1];
    var margin = 1;
    var _j = (0, react_1.useState)(''), pageNumber = _j[0], setPageNumber = _j[1];
    /**
     * 初始化
     */
    var initial = function () {
        var contentWidth = window.innerWidth;
        if (contentWidth < 500) {
            setRange(4);
        }
        else {
            setRange(7);
        }
    };
    (0, react_1.useEffect)(function () {
        // eslint-disable-next-line no-console
        // console.log(pageIndexState, '设置分页值');
        pageIndexState && setCurrentPage(pageIndexState);
        initial();
        window.addEventListener('resize', initial);
        return function () {
            window.removeEventListener('resize', initial);
        };
    }, [pageIndexState]);
    function handleClick(data) {
        if (disabled)
            return;
        setCurrentPage(data);
        onPagingChange === null || onPagingChange === void 0 ? void 0 : onPagingChange({
            pageSize: pageSizeTransform,
            pageIndex: data,
        });
    }
    var breaks = -10;
    function pagination() {
        var pageIndex = currentPage - 1;
        var items = [];
        if (totalPage < range) {
            for (var index = 0; index < totalPage; index += 1) {
                items.push(index + 1);
            }
        }
        else {
            var leftSide = range / 2;
            var rightSide = range - leftSide;
            if (pageIndex > totalPage - range / 2) {
                rightSide = totalPage - pageIndex;
                leftSide = range - rightSide;
            }
            else if (pageIndex < range / 2) {
                leftSide = pageIndex;
                rightSide = range - leftSide;
            }
            for (var index = 0; index < totalPage; index += 1) {
                var page = index + 1;
                if (page <= margin) {
                    items.push(page);
                    continue;
                }
                if (page > totalPage - margin) {
                    items.push(page);
                    continue;
                }
                if (index > pageIndex - leftSide && index <= pageIndex + rightSide) {
                    items.push(page);
                    continue;
                }
                if (items[items.length - 1] !== breaks) {
                    breaks = -10;
                    items.push(breaks);
                }
            }
        }
        return items;
    }
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    /**
     * 跳转分页
     * @param value
     */
    var onPressEnter = function (value) {
        var page = Number(value);
        var pageNumber;
        if (page > totalPage) {
            pageNumber = totalPage;
        }
        else {
            pageNumber = page < 1 ? 1 : page;
        }
        setCurrentPage(Number(pageNumber));
        setPageNumber(String(pageNumber));
        onPagingChange === null || onPagingChange === void 0 ? void 0 : onPagingChange({ pageSize: pageSizeTransform, pageIndex: pageNumber });
    };
    return totalPage > 1 ? (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)("".concat(classPrefix, "__pagination-warp"), className) },
        react_1.default.createElement("div", { className: "".concat(classPrefix, "__page") },
            currentPage > 1 && (react_1.default.createElement("span", { className: (0, classnames_1.default)('pages-item-prev', {
                    'pages-item-next--disabled': disabled,
                }), onClick: function () { return handleClick(currentPage - 1); } },
                react_1.default.createElement(icon_1.default, { name: "right-outlined", size: 18, color: "".concat(disabled ? 'rgba(0,0,0,0.15' : 'rgba(0, 0, 0, 0.6)') }))),
            pagination().map(function (page, index) {
                // eslint-disable-next-line no-console
                // console.log(pagination(), page, '分页测试', currentPage, currentPage === page);
                if (page === -10) {
                    return (react_1.default.createElement("span", { className: "dot", key: index }, "..."));
                }
                return (react_1.default.createElement("span", { className: (0, classnames_1.default)('pages-item', {
                        'pages-item--active': page === currentPage,
                        'pages-item--disabled': disabled,
                    }), key: index, onClick: function () { return handleClick(page); } }, page));
            }),
            currentPage < totalPage && (react_1.default.createElement("span", { className: (0, classnames_1.default)('pages-item-next', {
                    'pages-item-next--disabled': disabled,
                }), onClick: function () { return handleClick(currentPage + 1); } },
                react_1.default.createElement(icon_1.default, { name: "right-outlined", size: 18, color: "".concat(disabled ? 'rgba(0,0,0,0.15' : 'rgba(0, 0, 0, 0.6)') })))),
        totalPage > 10 ? (react_1.default.createElement("div", { className: "".concat(classPrefix, "__jump") },
            react_1.default.createElement("div", null,
                react_1.default.createElement(antd_1.Input, { disabled: disabled, className: "pages-jump", placeholder: placeholder, onPressEnter: function (e) {
                        var v = e.target.value;
                        onPressEnter(v);
                    }, value: String(pageNumber), onChange: function (e) {
                        var v = e.target.value;
                        setPageNumber(!isNaN(Number(v)) ? v : '');
                    } }),
                react_1.default.createElement("span", { className: "pages-txt" }, pageText),
                pageNumber ? (react_1.default.createElement(antd_1.Button, { className: "pages-but", onClick: function () {
                        onPressEnter(pageNumber);
                    } }, goText)) : null))) : null)) : null;
}
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map